import { GfsOfferPestsPage } from "@/services/backend/gfs/offer/components/offer-pests-page";

export default function GfsOfferPestsRoute() {
  return <GfsOfferPestsPage />;
}
